<template>
  <a-modal destroyOnClose style="height: 80%;overflow-y: auto;" width="80%" v-model="visible" @cancel="close" @ok="handleOk" cancelText="关闭" okText="提交" :closable="false" :destroyOnClose="true" :maskClosable="false">
    <a-row slot="title" style="margin-bottom: 10px">
      <a-row>
        填空题
      </a-row>
    </a-row>
    <a-spin :spinning="loading">
      <a-row>
        <a-form-model :label-col="labelCol" :wrapper-col="wrapperCol">
          <a-form-model-item label="是否必做">
            <a-radio-group :options="requiredOptions" v-model="drill.required"/>
          </a-form-model-item>
          <a-form-model-item label="答案是否无序">
            <a-radio-group :options="unorderedOptions" v-model="drill.unordered"/>
          </a-form-model-item>
          <a-form-model-item label="题干">
            <a-textarea style="width: 80%" @change="changeDrillText" v-model="drill.text" placeholder="请输入题干，空格用方括号替代，如：中国首都是[]?"/>
          </a-form-model-item>
          <a-form-model-item label="题干音频" v-if="subType == 202">
            <AudioUpload :defaultUrl="drill.audioUri ? `${this.$ossHost}${drill.audioUri}`: undefined" @changeUri="changeAudioUri" path="audio/drill/"/>
          </a-form-model-item>
          <a-form-model-item label="题图">
            <CommonUpload :defaultUrl="this.drill.imageUri ? `${$ossHost}${this.drill.imageUri}`: undefined" @changeImgUri="changeImgUri" path="img/drill/"/>
          </a-form-model-item>
          <!-- <a-form-model-item v-for="(answer, index) in drill.correctAnswerSource" :label="`第${index+1}空`" :key="index">
            <a-input style="width: 60%" v-model="answer.value" :placeholder="`请输入第${index+1}个空答案，多个答案请使用|分割`"/>
          </a-form-model-item> -->
          <a-form-model-item label="答案">
            <a-row v-for="(answer, index) in drill.correctAnswerSource" :key="index">
              <a-input style="width: 80%" v-model="answer.value" :placeholder="`请输入第${index+1}个空答案，多个答案请使用|分割`"/>
              <a-icon
                class="dynamic-delete-button"
                type="minus-circle-o"
                @click="() => removeAnswer(index)"/>
            </a-row>
            <a-button style="width: 80%;" @click="addCorrectAnswerSource">
              增加空
            </a-button>
          </a-form-model-item>
          <a-form-model-item label="解析">
            <a-textarea style="width: 80%" v-model="drill.explanation" placeholder="请输入解析"/>
          </a-form-model-item>
        </a-form-model>
      </a-row>
    </a-spin>
  </a-modal>
</template>

<script>
import {mapActions} from "vuex";
import { deepClone } from '@clownlee/utils'
const OSS = require('ali-oss')
const letter = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
import CommonUpload from '../../../../components/CommonUpload.vue'
import AudioUpload from '../../../../components/AudioUpload.vue'
import GapFillingDrillApi from '../../../../api/src/drill/api/GapFillingDrillApi.js'
const gapFillingDrillApi = new GapFillingDrillApi()
export default {
  name: "GapFillingEdit",
  props: {
    visibleTimes: Number,
    info: Object,
    treeData: Array,
    subType: Number,
    selectedKeys: Array,
    currentDrillId: String,
    sectionId: String,
  },
  components: {CommonUpload, AudioUpload},
  watch: {
    'visibleTimes': async function(a, b) {
      this.visible = true
      if(this.currentDrillId){
        console.debug(this.currentDrillId)
        this.loading = true
        let resp = await gapFillingDrillApi.getDetail(this.currentDrillId)
        console.log(resp)
        resp.correctAnswerSource = resp.correctAnswer.map(answer => {
          return {
            value: answer.join('|')
          }
        })
        this.drill = resp
        console.debug(resp)
        this.loading = false
        return
      }
    },
  },
  data() {
    return {
      letter: letter,
      labelCol: { span: 4 },
      wrapperCol: { span: 20 },
      formItemLayoutWithOutLabel: {
        wrapperCol: {
          xs: { span: 24, offset: 0 },
          sm: { span: 20, offset: 4 },
        },
      },
      requiredOptions: [{
        value: false,
        label: '否'
      },{
        value: true,
        label: '是'
      }],
      unorderedOptions: [{
        value: false,
        label: '否'
      },{
        value: true,
        label: '是'
      }],
      drill: {
        required: false,
        unordered: false,
        text: undefined,
        correctAnswerSource: [],
        correctAnswer: [],
        explanation: undefined
      },
      fragmentList: [],
      uploading: false,
      loading: false,
      visible: false
    }
  },
  methods:{
    changeImgUri(uri) {
      this.drill.imageUri = uri
      console.log(uri)
    },
    changeDrillText(e) {
      // console.log(e.target.value)
      // let fillingNum = e.target.value.split('[]').length - 1
      // if(this.drill.correctAnswerSource.length < fillingNum){
      //   let addFill = []
      //   for(let i = 0; i < fillingNum - this.drill.correctAnswerSource.length; i++){
      //     addFill.push({
      //       value: ''
      //     })
      //   }
      //   this.drill.correctAnswerSource = this.drill.correctAnswerSource.concat(addFill)
      // }else if(this.drill.correctAnswerSource.length > fillingNum){
      //   this.drill.correctAnswerSource = this.drill.correctAnswerSource.slice(0, fillingNum)
      // }
    },
    addCorrectAnswerSource() {
      let correctAnswerSource = deepClone(this.drill.correctAnswerSource)
      correctAnswerSource.push({
        value: ''
      })
      this.drill.correctAnswerSource = correctAnswerSource
    },
    removeAnswer(index) {
      let correctAnswerSource = deepClone(this.drill.correctAnswerSource)
      correctAnswerSource.splice(index, 1)
      this.drill.correctAnswerSource = correctAnswerSource
    },
    beforeUpload(file) {
      let fragment = {
        title: undefined,
        type: 1,
        summary: undefined,
        isVideo: false,
        knowledgeId: this.info.knowledgeId,
        progress: 0,
        file: file
      }
      if(/video/ig.test(fragment.file.type)){
        fragment.isVideo = true
      }
      this.fragmentList.push(fragment)
      return false
    },
    handleChangeFile(e) {
    },
    handlePreview() {

    },
    getDetail() {

    },
    close() {
      if(this.loading){
        this.$message.warning('试题正在上传中，请稍后')
        return
      }
      this.$emit('success', {addDrill: true})
      this.visible = false
      this.drill = {
        required: false,
        text: undefined,
        correctAnswerSource: [],
        correctAnswer: [],
        explanation: undefined,
        unordered: false,
        audioUri: undefined
      }
    },
    deleteFile(fragment, index) {
    },
    async handleOk() {
      console.log(this.drill)
      if(!this.drill.text){
        this.$message.error('请填写题干')
        return
      }
      if(this.drill.correctAnswerSource.filter(answer => {return answer.value == ''}).length >= 1) {
        this.$message.error('请填写正确答案')
        return
      }
      for(let i = 0; i < this.drill.correctAnswerSource.length; i++){
        this.drill.correctAnswer = this.drill.correctAnswerSource.map(answerSource => {
          return answerSource.value.split('|')
        })
      }
      if(this.drill.correctAnswer.length == 0){
        this.$message.error('请输入[]替代填空处')
        return
      }
      if(!this.drill.id){
        this.drill.subType = this.subType
      }
      console.debug(this.drill)
      console.debug(this.$route.params.courseStandardId)
      console.debug(this.selectedKeys[0])
      this.loading = true
      if(!this.drill.id){
        await gapFillingDrillApi.create(this.drill, {
          courseStandardId: this.$route.params.courseStandardId,
          knowledgeId: this.selectedKeys[0],
          sectionId: this.sectionId,
          sortKey: 0
        })
      }else{
        await gapFillingDrillApi.update(this.drill.id, this.drill)
      }
      this.visible = false
      this.drill = {
        required: false,
        text: undefined,
        correctAnswerSource: [],
        correctAnswer: [],
        explanation: undefined,
        unordered: false
      }
      this.loading = false
      this.$emit('success', {addDrill: true})
    },
    check() {
      console.log(this.fragmentList)
      let checkFlag = true
      for(let i = 0; i < this.fragmentList.length; i++) {
        if(!this.fragmentList[i].title){
          this.$message.error(`${this.fragmentList[i].file.name}无碎片名`)
          checkFlag = false
          break
        }
        if(!this.fragmentList[i].summary){
          this.$message.error(`${this.fragmentList[i].file.name}无碎片简介`)
          checkFlag = false
          break
        }
      }
      return checkFlag
    },
    async changeAudioUri(uri) {
      this.drill.audioUri = uri
    },
  }
}
</script>

<style scoped lang="less">
.dynamic-delete-button {
  cursor: pointer;
  position: relative;
  top: 4px;
  font-size: 24px;
  color: #999;
  transition: all 0.3s;
  margin-left: 10px;
}
.dynamic-delete-button:hover {
  color: #777;
}
</style>